interface PolicyPlanBalanceProps {
  balance: number
  lastUpdated: string
  directDebit?: boolean // optional prop to indicate if the balance will be debited from the user's bank account
}
/**
 * - Current Balance:
 * - $17.95
 * - Last Updated: -
 */
export default function PolicyPlanBalance({balance, lastUpdated, directDebit}: PolicyPlanBalanceProps) {
  return (
    <div className='plan-balance-box'>
      <p className='gray-text text-base'>{'Current Balance:'}</p>
      <p className='blue-title'>{`${balance}`}</p>
      <p className='gray-text text-base'>{`Last Updated: ${lastUpdated}`}</p>
      {directDebit ? (
        <p className='black-text text-base'>
          <strong>Your balance will be debited from your authorized bank account.</strong>
        </p>
      ) : null}
    </div>
  )
}
